import type {
  SYSColumnDef,
  SYSTableDef,
} from "../../../../../_ovlclient/src/library/table/tableapi"

export type UserAdministration_UserType = {
  CntctCode?: number
  FirstName: string
  LastName: string
  E_MailL: string
  CardCode: string
  U_ITFPrtUserId: string
  Active?: string
  U_ITFPrtUserData?: any
  AuthMode: string
  TOTPValidForDays: number
}

let columns: { [key in keyof UserAdministration_UserType]: SYSColumnDef } = {
  FirstName: {
    sortable: true,
    ui: { labelTranslationKey: "SYSUserAdministrationColFirstName" },
  },
  LastName: {
    sortable: true,
    ui: { labelTranslationKey: "SYSUserAdministrationColLastName" },
  },
  E_MailL: {
    sortable: true,
    ui: { labelTranslationKey: "SYSUserAdministrationColEmail" },
  },
  U_ITFPrtUserId: {
    sortable: true,
    ui: { labelTranslationKey: "SYSUserAdministrationColUserId" },
  },
  CardCode: {
    ui: { labelTranslationKey: "SYSUserAdministrationColCardName" },
    sortable: true,
    filter: {
      columnFilter: { type: "none" },
    },
    list: {
      displayField: "CardName",
      valueField: "CardCode",
      lookupDefKey: "CardCode",
      displayValueField: true,
      serverEndpoint: "useradministration/lookups/cardcode",
    },
    schema: { nullable: false },
  },

  Active: {
    control: "checkbox",
    filter: { columnFilter: { type: "none" } },
    ui: {
      checkedValue: "Y",
      labelTranslationKey: "SYSUserAdministrationColUserActive",
    },
  },

  AuthMode: {
    type: "text",
    schema: { isCalculatedColumn: true, nullable: false },
    list: {
      mode: "Select",
      displayField: "AuthModeDescription",
      valueField: "AuthModeCode",
    },
    ui: { visibility: "Table_Edit_View" },
  },

  TOTPValidForDays: {
    type: "int",
    schema: { isCalculatedColumn: true },
    list: {
      mode: "Select",
      displayField: "TOTPValidForDaysDescription",
      valueField: "TOTPValidForDaysCode",
    },
    ui: { visibility: "Edit" },
  },

  U_ITFPrtUserData: {
    type: "object",
    schema: { isRelevantForDirtyIfInactive: true },
    ui: {
      visibility: "Edit",
      fillSpaceIfNotVisible: false,
    },
  },
}

export let tblUserAdministration_User: SYSTableDef = {
  id: "SYSUserAdministration_User",
  permission: "SYSUA",
  feature: "SYSUserAdministration",
  database: {
    dataIdField: "CntctCode",
    dbInsertMode: "AutoIdentity",
  },
  server: {
    endpoint: "useradministration/user",
  },
  options: {
    feedback: { level: "4:success" },
    filterSortSettings: { selectionClipping: "Keep" },
    initial_sort: { field: "FirstName", direction: "asc" },
    initial_paging: { page: 0, pageSize: 200 },
    customRowActions: {
      AssignRoles: {
        translationKey: "SYSUserAdministrationAssignRoles",
        icon: "sap-icon--role",
      },
      SendCredentials: {
        translationKey: "SYSUserAdministrationSendCredentials",
        icon: "sap-icon--key",
        trackData: "Every5Secs",
        prompt: {
          type: "Always",
        },
        endpoint: { url: "useradministration/user/sendcredentials" },
        blocking: { group: "view" },
        handleFeedback: true,
        summary: "DialogIfMultiple",
        whenMultiple: {
          callForEveryRow: false,
        },
      },
      SendTOTPQRCode: {
        translationKey: "SYSUserAdministrationSendTOTPQRCode",
        icon: "sap-icon--two-keys",
        trackData: "Every5Secs",
        prompt: {
          type: "Always",
        },
        endpoint: { url: "useradministration/user/sendtotpqrcode" },
        blocking: { group: "view" },
        handleFeedback: true,
        summary: "DialogIfMultiple",
        whenMultiple: {
          callForEveryRow: false,
        },
      },
      SendMessage: {
        translationKey: "SYSUserAdministrationSendMessage",
        icon: "sap-icon--email",
        trackData: "Every5Secs",
        prompt: {
          type: "Always",
          connectedFormDefinition: {
            fields: {
              Subject: {
                control: "text",
                value: "Portal Message",
                schema: { nullable: false },
                ui: {
                  labelTranslationKey:
                    "SYSUserAdministrationSendMessageSubject",
                },
              },
              Message: {
                control: "textarea",
                ui: {
                  labelTranslationKey:
                    "SYSUserAdministrationSendMessageMessage",
                },
              },
            },
            fieldsResetType: "ResultHasOnlySuccess",
          },
        },
        endpoint: { url: "useradministration/user/sendmessage" },
        blocking: { group: "view" },
        handleFeedback: true,
        summary: "DialogIfMultiple",
        whenMultiple: {
          callForEveryRow: false,
        },
      },
    },
  },

  features: {
    add: true,
    edit: true,
    delete: true,
    focusToFirstEditableField: true,
    filter: true,
    multiSelect: true,
    multiFilter: true,
  },
  columns,
}
